import {ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {CustomerAuthService} from 'src/app/public/customer-auth.service';
import {LocationService} from 'src/app/public/location.service';
import {getCustomerProfileState, getSelectedStore} from '../../+state/stores.selectors';
import {CustomerProfileState} from '../../+state/stores.reducer';
import {filter} from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.scss',
})
export class ProfileMenuComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Input() variant: 'avatar' | 'menu' = 'menu';
  customerProfileState: CustomerProfileState;
  profilePicture = '';
  loyaltyEnabled = false;

  constructor(
    public auth: CustomerAuthService,
    private router: Router,
    private locationService: LocationService,
    private store: Store<any>,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.store
      .select(getCustomerProfileState)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((state: CustomerProfileState) => {
        this.customerProfileState = state;
        this.profilePicture = state?.data?.profilePicture || '';
        if (this.profilePicture && state?.profilePictureSalt) {
          this.profilePicture = `${this.profilePicture}?salt=${state.profilePictureSalt}`;
        }
        this.cdr.detectChanges();
      });

    this.store
      .select(getSelectedStore)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((selectedStore) => !!selectedStore)
      )
      .subscribe((selectedStore) => {
        this.loyaltyEnabled = !!selectedStore.settings.LOYALTY_SCHEME;
      });
  }

  onProfileClick() {
    this.router.navigateByUrl(this.locationService.base_url('profile'));
  }

  onLoyaltyClick() {
    this.router.navigateByUrl(this.locationService.base_url('profile/loyalty'));
  }

  onLogoutClick() {
    this.auth.logout();
    this.router.navigateByUrl(this.locationService.base_url(''));
  }
}
